import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b03dcc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "air-card" }
const _hoisted_2 = { class: "expression" }
const _hoisted_3 = { class: "aqi-value" }
const _hoisted_4 = { class: "factor-value" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "factor-txt" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 首要污染物：")
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "card-bottom" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("PM"),
  /*#__PURE__*/_createElementVNode("sub", null, "2.5")
], -1))
const _hoisted_11 = { class: "unit" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("PM"),
  /*#__PURE__*/_createElementVNode("sub", null, "10")
], -1))
const _hoisted_13 = { class: "unit" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("SO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1))
const _hoisted_15 = { class: "unit" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("NO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2")
], -1))
const _hoisted_17 = { class: "unit" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("O"),
  /*#__PURE__*/_createElementVNode("sub", null, "3")
], -1))
const _hoisted_19 = { class: "unit" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "CO", -1))
const _hoisted_21 = { class: "unit" }

import qs from 'qs';
import { useStore, } from 'vuex';
import {
  computed, onMounted, watch, ref,
} from 'vue';
import { Progress, } from 'ant-design-vue';
import {
  fontColorRender,
  factorColorRender,
  factorEmoRender,
  getAqiSuggestion,
  // factorFontColorRender,
} from '@/utils/index';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const frameData = computed(() => store.state.gateway.frameData);
const regionId = computed(() => store.state.OLMap.regionId) || 320100000000;

// 要素对应文字
const factorKey = {
  PM25: '<span>PM<sub>2.5</sub></span>',
  PM10: '<span>PM<sub>10</sub></span>',
  SO2: '<span>SO<sub>2</sub></span>',
  NO2: '<span>NO<sub>2</sub></span>',
  CO: 'CO',
  O3: '<span>O<sub>3</sub></span>',
};

watch(regionId, (cur) => {
  if (cur !== '') {
    const params = { regionId: cur, };

    store.dispatch('gateway/getAirFrameData', params);
  }
});
onMounted(() => {
  if (regionId.value) {
    const params = { regionId: regionId.value, };

    store.dispatch('gateway/getAirFrameData', params);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card-top",
      style: _normalizeStyle({
        'background-color': _unref(factorColorRender)(_unref(frameData).aqi !== '-9999' && _unref(frameData).aqi !== null ? Number(Number(_unref(frameData).aqi).toFixed(0)) : -9999, 'aqi')
      })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: _normalizeClass([
            'iconfont',
            `icon-emo-${_unref(factorEmoRender)(_unref(frameData).aqi !== '-9999' && _unref(frameData).aqi !== null ? Number(Number(_unref(frameData).aqi).toFixed(0)) : -9999, 'aqi')}`
          ]),
          style: _normalizeStyle({
            'color': _unref(fontColorRender)(_unref(frameData).aqi !== '-9999' && _unref(frameData).aqi !== null ? Number(Number(_unref(frameData).aqi).toFixed(0)) : -9999, 'aqi')
          })
        }, null, 6)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "value-txt",
          style: _normalizeStyle({
            'color': _unref(fontColorRender)(_unref(frameData).aqi !== '-9999' && _unref(frameData).aqi !== null ? Number(Number(_unref(frameData).aqi).toFixed(0)) : -9999, 'aqi')
          })
        }, _toDisplayString(_unref(frameData).aqi !== '-9999' && _unref(frameData).aqi !== null ? Number(_unref(frameData).aqi).toFixed(0) : '-'), 5),
        _createElementVNode("div", {
          class: "name-txt",
          style: _normalizeStyle({
            'color': _unref(fontColorRender)(_unref(frameData).aqi !== '-9999' && _unref(frameData).aqi !== null ? Number(Number(_unref(frameData).aqi).toFixed(0)) : -9999, 'aqi')
          })
        }, " AQI指数 ", 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "prompt-language",
          title: _unref(frameData).suggestion || _unref(getAqiSuggestion)(Number(_unref(frameData).aqi)),
          style: _normalizeStyle({
            'color': _unref(fontColorRender)(_unref(frameData).aqi !== '-9999' && _unref(frameData).aqi !== null ? Number(Number(_unref(frameData).aqi).toFixed(0)) : -9999, 'aqi')
          })
        }, _toDisplayString(_unref(frameData).suggestion || _unref(getAqiSuggestion)(_unref(frameData).aqi !== '-9999' && _unref(frameData).aqi !== null ? Number(Number(_unref(frameData).aqi).toFixed(0)) : -9999)), 13, _hoisted_5),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "name-txt",
            style: _normalizeStyle({
              'color': _unref(factorColorRender)(_unref(frameData).aqi !== '-9999' && _unref(frameData).aqi !== null ? Number(Number(_unref(frameData).aqi).toFixed(0)) : -9999, 'aqi') !== '#FFFE05' ? _unref(factorColorRender)(Number(_unref(frameData).aqi), 'aqi') : 'rgb(68, 67, 0)'
            })
          }, [
            _hoisted_7,
            _createElementVNode("span", {
              innerHTML: factorKey[_unref(frameData).pollutant || _unref(frameData).firstPollution] || '-'
            }, null, 8, _hoisted_8)
          ], 4)
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode(_unref(Progress), {
        percent: _unref(frameData).pm25 / 2.5,
        size: "small",
        showInfo: false,
        strokeColor: _unref(factorColorRender)(Number(_unref(frameData).pm25), 'pm25'),
        trailColor: `${_unref(factorColorRender)(Number(_unref(frameData).pm25), 'pm25')}11`
      }, null, 8, ["percent", "strokeColor", "trailColor"]),
      _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(frameData).pm25 !== '-9999' && _unref(frameData).pm25 !== null ? _unref(frameData).pm25 : '-') + "μg/m³", 1),
      _hoisted_12,
      _createVNode(_unref(Progress), {
        percent: _unref(frameData).pm10 / 5,
        size: "small",
        showInfo: false,
        strokeColor: _unref(factorColorRender)(Number(_unref(frameData).pm10), 'pm10'),
        trailColor: `${_unref(factorColorRender)(Number(_unref(frameData).pm10), 'pm10')}11`
      }, null, 8, ["percent", "strokeColor", "trailColor"]),
      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(frameData).pm10 !== '-9999' && _unref(frameData).pm10 !== null ? _unref(frameData).pm10 : '-') + "μg/m³", 1),
      _hoisted_14,
      _createVNode(_unref(Progress), {
        percent: _unref(frameData).so2,
        size: "small",
        showInfo: false,
        strokeColor: _unref(factorColorRender)(Number(_unref(frameData).so2), 'so2'),
        trailColor: `${_unref(factorColorRender)(Number(_unref(frameData).so2), 'so2')}11`
      }, null, 8, ["percent", "strokeColor", "trailColor"]),
      _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(frameData).so2 !== '-9999' && _unref(frameData).so2 !== null ? _unref(frameData).so2 : '-') + "μg/m³", 1),
      _hoisted_16,
      _createVNode(_unref(Progress), {
        percent: _unref(frameData).no2,
        size: "small",
        showInfo: false,
        strokeColor: _unref(factorColorRender)(Number(_unref(frameData).no2), 'no2'),
        trailColor: `${_unref(factorColorRender)(Number(_unref(frameData).no2), 'no2')}11`
      }, null, 8, ["percent", "strokeColor", "trailColor"]),
      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(frameData).no2 !== '-9999' && _unref(frameData).no2 !== null ? _unref(frameData).no2 : '-') + "μg/m³", 1),
      _hoisted_18,
      _createVNode(_unref(Progress), {
        percent: _unref(frameData).o3 / 3,
        size: "small",
        showInfo: false,
        strokeColor: _unref(factorColorRender)(Number(_unref(frameData).o3),'o3'),
        trailColor: `${_unref(factorColorRender)(Number(_unref(frameData).o3), 'o3')}11`
      }, null, 8, ["percent", "strokeColor", "trailColor"]),
      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(frameData).o3 !== '-9999' && _unref(frameData).o3 !== null ? _unref(frameData).o3 : '-') + "μg/m³", 1),
      _hoisted_20,
      _createVNode(_unref(Progress), {
        percent: _unref(frameData).co * 10,
        size: "small",
        showInfo: false,
        strokeColor: _unref(factorColorRender)(Number(_unref(frameData).co), 'co'),
        trailColor: `${_unref(factorColorRender)(Number(_unref(frameData).co), 'co')}11`
      }, null, 8, ["percent", "strokeColor", "trailColor"]),
      _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(frameData).co !== '-9999' && _unref(frameData).co !== null ? _unref(frameData).co : '-') + "mg/m³", 1)
    ])
  ]))
}
}

})